import { motion, AnimatePresence } from "framer-motion";

const REASONS = [
  "Current company isn't reliable",
  "Pool isn't staying clean or clear",
  "Poor communication from current company",
  "Looking for better service",
  "Current company stopped servicing my area",
  "New homeowner / recently purchased the property",
  "I currently maintain the pool myself",
  "Other",
];

export const QualificationQuestion = ({ value, onChange, testidPrefix }) => {
  const select = (r) => onChange({ choice: r, otherText: r === "Other" ? value.otherText : "" });

  return (
    <div data-testid={`${testidPrefix}-reason-question`}>
      <p className="block text-sm font-semibold text-navy mb-1.5">
        What has you looking for a new pool service?{" "}
        <span className="font-normal text-slate-400">(optional)</span>
      </p>
      <div className="grid grid-cols-2 gap-2">
        {REASONS.map((r) => {
          const active = value.choice === r;
          return (
            <button
              key={r}
              type="button"
              data-testid={`${testidPrefix}-reason-${r.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              onClick={() => select(r)}
              aria-pressed={active}
              className={`text-left text-[13px] sm:text-sm font-medium rounded-xl border px-3 py-2.5 leading-snug transition-all duration-200 ${
                active
                  ? "border-lagoon bg-pine text-white shadow-md shadow-emerald-900/10"
                  : "border-slate-300 bg-white text-slate-600 hover:border-lagoon hover:text-navy"
              }`}
            >
              {r}
            </button>
          );
        })}
      </div>
      <AnimatePresence>
        {value.choice === "Other" && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.25 }}
            className="overflow-hidden"
          >
            <input
              data-testid={`${testidPrefix}-reason-other-input`}
              value={value.otherText}
              onChange={(e) => onChange({ ...value, otherText: e.target.value })}
              placeholder="Tell us briefly…"
              maxLength={200}
              className="mt-3 w-full rounded-xl border border-slate-300 bg-white px-4 py-3 text-navy placeholder:text-slate-400 outline-none transition-[border-color,box-shadow] duration-200 focus:border-pool focus:ring-4 focus:ring-cyan-500/15"
            />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export const formatReason = ({ choice, otherText }) => {
  if (!choice) return null;
  if (choice === "Other") return otherText.trim() ? `Other: ${otherText.trim()}` : "Other";
  return choice;
};
